export default "__VITE_ASSET__Cmp6pLEQ__"